import axiosInstance from '../../../api/axiosConfig';
import { Order, AddOrder } from '../../../types/order';

export const getOrders = async (params = {}) => {
    const response = await axiosInstance.get<Order[]>('/order', { params });
    return response?.data;
};

export const getOrder = async (id: number) => {
    const response = await axiosInstance.get<Order>(`/order/${id}`);
    return response?.data;
};

export const createOrder = async (order: AddOrder) => {
    const response = await axiosInstance.post<Order>('/order', order);
    return response?.data;
};

export const updateOrder = async (id: number, order: Partial<AddOrder>) => {
    const response = await axiosInstance.patch<Order>(`/order/${id}`, order);
    return response?.data;
};
